// extracted by mini-css-extract-plugin
export default {"container":"Form_container__YbZZh","btn":"Form_btn__F1hel","selection":"Form_selection__+uSIY"};